import { Controller } from "@hotwired/stimulus";
import {
  AdminPreferences,
  AdminPreferencesTracker,
  PreferenceUpdate
} from "controllers/admin/admin_preferences_tracker";

export default class AdminPreferencesController extends Controller {
  updateHook?: PreferenceUpdate;

  connect() {
    this.updateHook ??= this.updateSelectedPreferences.bind(this);
    AdminPreferencesTracker.instance().register(this.updateHook);
  }

  updateSelectedPreferences(_prefs: AdminPreferences) {
    // Handle your preferred preferences' selections selectively here
  }
}
